// Load animation
window.addEventListener('load', () => {
  document.body.classList.add('loaded');
});

// Scroll reveals
const revealEls = document.querySelectorAll('.reveal, [data-sol-motion="reveal"]');
if (revealEls.length) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  revealEls.forEach(el => revealObserver.observe(el));
}

// Regenerative cuisine art layers
const parallaxEls = document.querySelectorAll('.sol-parallax[data-sol-depth]');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
if (parallaxEls.length && !reduceMotion.matches) {
  let ticking = false;

  const updateParallax = () => {
    const viewportCenter = window.innerHeight / 2;
    parallaxEls.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const depth = Number(el.dataset.solDepth || 0);
      const distance = (rect.top + rect.height / 2) - viewportCenter;
      const offset = Math.max(-90, Math.min(90, distance * depth));
      el.style.setProperty('--sol-parallax-y', offset.toFixed(2));
    });
    ticking = false;
  };

  const requestParallax = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  };

  updateParallax();
  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax);
}

// Nav scroll state
const nav = document.querySelector('.sol-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 80);
  }, { passive: true });
}

// Mobile hamburger menu
const hamburger = document.getElementById('nav-hamburger');
const navLinks = document.getElementById('nav-links');
if (hamburger && navLinks) {
  hamburger.addEventListener('click', () => {
    const isOpen = navLinks.classList.toggle('open');
    hamburger.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });
  navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      navLinks.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
}

// Modal popups (e.g. GHL opt-in form embeds)
document.querySelectorAll('[data-modal-open]').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const modal = document.getElementById(trigger.dataset.modalOpen);
    if (modal) {
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  });
});
document.querySelectorAll('.sol-modal').forEach(modal => {
  modal.addEventListener('click', (e) => {
    if (e.target === modal || e.target.closest('[data-modal-close]')) {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }
  });
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    document.querySelectorAll('.sol-modal.open').forEach(modal => {
      modal.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
});

// Product variant selection — live price, variant id, availability
document.querySelectorAll('.product-form').forEach(form => {
  const dataEl = form.querySelector('[data-product-variants]');
  if (!dataEl) return;

  let variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const radios = form.querySelectorAll('.variant-radio');
  const priceEl = document.querySelector('[data-product-price]');
  const idInput = form.querySelector('input[name="id"]');
  const addBtn = form.querySelector('.add-to-cart');

  function findVariant() {
    const selected = {};
    radios.forEach(r => {
      if (r.checked) {
        const position = r.name.split('-')[1];
        selected['option' + position] = r.value;
      }
    });
    return variants.find(v => Object.keys(selected).every(key => v[key] === selected[key]));
  }

  function updateUI() {
    const variant = findVariant();
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price_html;
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
  }

  radios.forEach(r => r.addEventListener('change', updateUI));
});
